"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.durationFromSeconds = void 0;
function durationFromSeconds(totalSeconds) {
    const minutes = Math.floor(totalSeconds / 60);
    const seconds = Math.floor(totalSeconds - minutes * 60);
    return `${minutes}:${seconds < 10 ? '0' : ''}${seconds}`;
}
exports.durationFromSeconds = durationFromSeconds;
//# sourceMappingURL=durationFromSeconds.js.map